import { useEffect } from 'react';
import { fontSpec } from '../components/customer/mealpass/storefrontTheme';

/**
 * useStorefrontFonts — load the families a storefront actually uses (v5.66).
 *
 * The Design Studio font selects used to offer families that nothing
 * loaded — including the renderer's own default body font — so every
 * choice silently fell back to the system stack. Each family the theme
 * knows is fetched from Google Fonts on demand, once, by a stable
 * `<link data-sf-font>` per family; unknown families are ignored (a
 * merchant's typed value that is not in the catalogue never 404s a
 * stylesheet).
 */
const loaded = new Set();

export const googleFontsHref = (family) => {
  const spec = fontSpec(family);
  if (!spec) return null;
  return `https://fonts.googleapis.com/css2?family=${encodeURIComponent(spec.family).replace(/%20/g, '+')}:${spec.axis}&display=swap`;
};

export const ensureStorefrontFont = (family) => {
  if (typeof document === 'undefined') return;
  const href = googleFontsHref(family);
  if (!href || loaded.has(href)) return;
  loaded.add(href);
  if (document.querySelector(`link[data-sf-font="${CSS.escape ? CSS.escape(family) : family}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.setAttribute('data-sf-font', family);
  document.head.appendChild(link);
};

export default function useStorefrontFonts(families) {
  const key = (families || []).filter(Boolean).join('|');
  useEffect(() => {
    key.split('|').filter(Boolean).forEach(ensureStorefrontFont);
  }, [key]);
}
